import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        const hash = location.hash.substring(1);
        const params = new URLSearchParams(hash);
        const sessionId = params.get('session_id');

        if (!sessionId) {
          throw new Error('No session ID found');
        }

        const response = await axios.post(`${API}/auth/session?session_id=${sessionId}`, {}, {
          withCredentials: true
        });

        navigate('/my-sessions', { state: { user: response.data }, replace: true });
      } catch (err) {
        console.error('Auth error:', err);
        setError(err.message);
        setTimeout(() => navigate('/'), 3000);
      }
    };

    processAuth();
  }, [location, navigate]);

  if (error) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <p className="text-red-500 mb-4">Authentication failed: {error}</p>
          <p className="text-gray-600">Redirecting to home...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-12 w-12 animate-spin text-[#0047AB] mx-auto mb-4" />
        <p className="text-[#64748B]">Completing authentication...</p>
      </div>
    </div>
  );
};

export default AuthCallback;